import { defineStore } from "pinia"

import { WeixinEnum } from "@/components/Login/hooks/useTabs";

export const useBasic = defineStore('basic', {
  state: () => {
    return {
      loginToggle: {
        toggle: false,
        type: WeixinEnum.WeixinLogin,
      }
    }
  },
  actions: {
    onOpenLoginModal() {
      this.loginToggle = {
        toggle: true,
        type: WeixinEnum.WeixinLogin,
      };
    },
    onOpenRegisterModal() {
      this.loginToggle = {
        toggle: true,
        type: WeixinEnum.WeixinRegister,
      };
    }
  }
})
